import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate ,useLocation} from "react-router-dom"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import { months_list } from "../../Shared/List";
import { FaTimes, FaFileExport } from "react-icons/fa"

import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const ExpenseDetails = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [expenses, setExpenses] = useState([])
    const [pinnedBottomRowData, setPinnedBottomRowData]  = useState([])
    const [title, setTitle] = useState('')
    const [show, setShow] = useState(false);
    const [publicID, setPublicID] = useState()
    const gridRef = useRef();

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.state){
            const {payload} = location.state
            setTitle(`${months_list[payload.month - 1].name} - ${payload.year}, ${payload.name} Expense Detail`)
            fetchData(payload)
        }
    }, [])

    const [columnDefs] = useState([
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        {
            headerName: "Date",
            field: "date",
            sortable: true,
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (filterDate, cellValue) => {
                  const cellDate = new Date(cellValue);
                  cellDate.setHours(0, 0, 0, 0);
                  filterDate.setHours(0, 0, 0, 0);
        
                  if (cellDate < filterDate) return -1;
                  if (cellDate > filterDate) return 1;
                  return 0;
                },
            },
        },
        {
            headerName: "User",
            field: "user",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Remark",
            field: "remark",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Amount",
            field: "debit",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Cancel",
            cellRenderer: (e) => {
                if (e.node.rowPinned) return '';
                return <button className="btn btn-outline-danger" onClick={()=> 
                handleShow(e.data.public_id)}><FaTimes/></button>
            },
            sortable: false,
            filter: false,
        },
    ]);

    const getRowStyle = (params) => {
        if (params.node.rowPinned) {
          return {
            backgroundColor: '#f8f9fa',
            fontWeight: 'bold',
            color: '#000',
          };
        }
        return {};
    };

    const fetchData = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`/expenses/detail?year=${payload.year}&month=${payload.month}&public_id=${payload.public_id}`)
            setExpenses(response?.data)
            setIsLoading(false)

            const output = response?.data.reduce((data, row) => {
                data.debit += parseFloat(row.debit);
                return data;
            }, {debit: 0.00});
            setPinnedBottomRowData([
                {
                    debit: parseFloat(output.debit).toFixed(2),
                }
            ]);
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data)
            }
        }
    }

    const handleClose = () => {
        setShow(false)
    }
    
    const handleShow = (public_id) => {
        setShow(true)
        setPublicID(public_id)
    };

    const handleDelete = async (public_id) => {
        setShow(false)
        try {
            setIsLoading(true)
            const response = await Server.delete(`/expenses/${public_id}`)
            if (response.status === 200){
                toast.success(response.data.detail)
                setExpenses(expenses.filter((expense) => expense.public_id !== public_id))
                setIsLoading(false)
            }else{
                setIsLoading(false)
                toast.error(response.data.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else{
                toast.error(error.response.data?.detail)
            }
        }
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
      const onExportClick=()=>{
        gridApi.exportDataAsCsv({ fileName: `${title}.csv` })
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="row">
            <div className="col-md-12">
                <button onClick={()=>onExportClick()} className="btn btn-success mb-2" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
            </div>
        </div>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
            <div className="row">
                <div className="col-md-12">
                    <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            suppressMenuHide={true}
                            rowData={expenses}
                            domLayout={"normal"}
                            rowSelection={"multiple"}
                    
                            animateRows={true}
                        
                            pagination={false}
                        
                            resizable={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}
                        
                        
                            ref={gridRef}
                            pinnedBottomRowData={pinnedBottomRowData}
                            getRowStyle={getRowStyle}
                            onGridReady={onGridReady}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                </div>
            </div>
        </div>
        </div>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title>Delete Alert</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure?</Modal.Body>
            <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
                No
            </Button>
            <Button variant="danger" onClick={() => handleDelete(publicID)}>
                Yes
            </Button>
            </Modal.Footer>
        </Modal>
      <br/>
    </>
  )
}

export default ExpenseDetails
